
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/ru";
import { apiRequests } from "src/shared/api/api";

dayjs.extend(relativeTime);
dayjs.locale("ru");

export const QUERY_KEYS = {
  CHATS: (token, filters) => ['chats', token, filters],
  CHAT_MESSAGES: (chatId, token) => ['chatMessages', chatId, token],
  CHANNELS: (token) => ['channels', token],
  CHAT_FILES: (chatId) => ['chatFiles', chatId],
  CONTRAGENTS: (token, search) => ['contragents', token, search]
};

export const fetchChats = async ({ queryKey }) => {
  const [, token, filters] = queryKey;
  const params = {
    token,
    limit: filters?.limit || 100,
    sort_by: filters?.sort_by || 'last_message_time',
    sort_order: filters?.sort_order || 'desc',
    ...filters
  };
  
  const response = await apiRequests.chats.getChats(params);
  return response.data || [];
};

export const fetchChannels = async ({ queryKey }) => {
  const [, token] = queryKey;
  const response = await apiRequests.chats.getChannels({ token });
  return response.data || [];
};

export const fetchChatMessages = async ({ queryKey }) => {
  const [, chatId, token] = queryKey;
  const response = await apiRequests.chats.getChatMessages(chatId, { 
    token,
    limit: 50 
  });
  return response.data?.data || [];
};

export const getSenderType = () => {
  return localStorage.getItem("sender_type") || "OPERATOR";
};

export const formatTime = (timestamp) => {
  if (!timestamp) return "";
  const date = dayjs(timestamp);
  const now = dayjs();
  
  if (date.isSame(now, "day")) {
    return date.format("HH:mm");
  } else if (date.isSame(now.subtract(1, "day"), "day")) {
    return "Вчера";
  } else if (date.isSame(now, "year")) {
    return date.format("D MMM");
  } else {
    return date.format("D.MM.YY");
  }
};

export const formatLastMessageTime = (timeString) => {
  if (!timeString) return "";
  
  try {
    const messageTime = dayjs(timeString);
    const now = dayjs();
    
    if (messageTime.isSame(now, "day")) {
      return messageTime.format("HH:mm");
    } else if (messageTime.isSame(now.subtract(1, "day"), "day")) {
      return "Вчера";
    } else if (messageTime.isSame(now, "year")) {
      return messageTime.format("D MMM");
    } else {
      return messageTime.format("DD.MM.YY");
    }
  } catch (error) {
    console.error("Error parsing time:", error);
    return "";
  }
};


export const playNotificationSound = (soundPath = null) => {
  try {
    const soundEnabled = localStorage.getItem('chat_sound_notifications') !== 'false';
    
    if (!soundEnabled) {
      return;
    }
    
    const audio = new Audio(soundPath || 'data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBSuBzvLZiTYIGGW57+OcTQ8MT6Tf8LZjHAY4kdfyzHksBSR3x/DdkEAKFF606euoVRQKRp/g8r5sIQUrgc7y2Yk2CBhlue/jnE0PDE+k3/C2YxwGOJHX8sx5LAUkd8fw3ZBAC');
    
    audio.volume = 0.5;
    
    audio.play().catch((error) => {
      console.debug('Не удалось воспроизвести звук уведомления:', error);
    });
  } catch (error) {
    console.debug('Ошибка при воспроизведении звука уведомления:', error);
  }
};

export const getWebSocketBaseURL = () => {
  const baseUrl = process.env.REACT_APP_APP_URL || window.location.hostname;
  const wsUrl = `wss://${baseUrl}`;
  return wsUrl;
};

export const processImageData = (data) => {
  if (!data) return null;
  
  
  if (data.startsWith('data:image')) {
    return data;
  }
  
  
  
  let mimeType = 'image/jpeg'; 
  
  if (data.startsWith('/9j/') || data.startsWith('/9j/4AA')) {
    mimeType = 'image/jpeg';
  } else if (data.startsWith('iVBORw0KGgo')) {
    mimeType = 'image/png';
  } else if (data.startsWith('R0lGOD')) {
    mimeType = 'image/gif';
  }
  
  return `data:${mimeType};base64,${data}`;
};


export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

export const truncatePreview = (text, maxLength = 40) => {
  if (!text) return "Нет сообщений";
  
  if (text.startsWith('data:image')) {
    return "Изображение";
  }
  
  if (text.length <= maxLength) return text;
  
  return text.substring(0, maxLength - 3) + "...";
};

export const isImageMessage = (text) => {
  return text && text.startsWith('data:image');
};